module.exports = __webpack_public_path__ + "static/img/success.13622b6a.png";